import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL_OLD,
  PROMOTION_FETCH,
  PROMOTION_ADD,
  PROMOTION_EDIT,
  PROMOTION_DELETE,
  M_POST,
  M_GET,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'promotion' })
export default class Promotion extends VuexModule {
  @Action
  FetchPromotion() {
    return Vue.axios({
      url: BASE_URL_OLD + PROMOTION_FETCH,
      method: M_GET,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const promotion = data.data;
          return promotion;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }

  @Action
  AddPromotion(params) {
    return Vue.axios({
      url: BASE_URL_OLD + PROMOTION_ADD,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditPromotion(params) {
    return Vue.axios({
      url: BASE_URL_OLD + PROMOTION_EDIT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  DeletePromotion(params) {
    return Vue.axios({
      url: BASE_URL_OLD + PROMOTION_DELETE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
